import './index.scss'

$('.section4 .open-up').on('click',function(e){
  e.preventDefault()
  $('.section4 .fixed-up').fadeIn(300)
})
$('.section4 .fixed-up .up-mask,.section4 .fixed-up .close-btn').on('click',function(){
  $('.section4 .fixed-up').fadeOut(300)
})